import apiClient from "@/api/client";
import type { SpreadsheetLink } from "@/features/tasks/types";

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const spreadsheetLinksApi = {
  listForTask: (taskId: string) =>
    apiClient.get<{ data: SpreadsheetLink[] }>(`/tasks/${taskId}/spreadsheet-links/`).then(wrap),

  createForTask: (taskId: string, data: { name: string; embed_code: string }) =>
    apiClient.post<{ data: SpreadsheetLink }>(`/tasks/${taskId}/spreadsheet-links/`, data).then(wrap),

  renameForTask: (taskId: string, linkId: string, name: string) =>
    apiClient.patch<{ data: SpreadsheetLink }>(`/tasks/${taskId}/spreadsheet-links/${linkId}/`, { name }).then(wrap),

  updateForTask: (taskId: string, linkId: string, data: { name: string; embed_code: string }) =>
    apiClient.patch<{ data: SpreadsheetLink }>(`/tasks/${taskId}/spreadsheet-links/${linkId}/`, data).then(wrap),

  deleteForTask: (taskId: string, linkId: string) =>
    apiClient.delete(`/tasks/${taskId}/spreadsheet-links/${linkId}/`),

  listForSubTask: (taskId: string, subtaskId: string) =>
    apiClient.get<{ data: SpreadsheetLink[] }>(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/`).then(wrap),

  createForSubTask: (taskId: string, subtaskId: string, data: { name: string; embed_code: string }) =>
    apiClient.post<{ data: SpreadsheetLink }>(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/`, data).then(wrap),

  renameForSubTask: (taskId: string, subtaskId: string, linkId: string, name: string) =>
    apiClient.patch<{ data: SpreadsheetLink }>(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/${linkId}/`, { name }).then(wrap),

  updateForSubTask: (taskId: string, subtaskId: string, linkId: string, data: { name: string; embed_code: string }) =>
    apiClient.patch<{ data: SpreadsheetLink }>(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/${linkId}/`, data).then(wrap),

  deleteForSubTask: (taskId: string, subtaskId: string, linkId: string) =>
    apiClient.delete(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/${linkId}/`),

  createTaskBackup: (taskId: string, linkId: string) =>
    apiClient.post(`/tasks/${taskId}/spreadsheet-links/${linkId}/backup/`),

  createSubTaskBackup: (taskId: string, subtaskId: string, linkId: string) =>
    apiClient.post(`/tasks/${taskId}/subtasks/${subtaskId}/spreadsheet-links/${linkId}/backup/`),
};
